import { render, staticRenderFns } from "./SsoCallback.vue?vue&type=template&id=156936f8"
import script from "./SsoCallback.vue?vue&type=script&lang=js"
export * from "./SsoCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../Development/graduation/graduate-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports